import { IBEError } from '@common/interfaces/be-error.interface';
import { UseQueryOptions } from '@common/interfaces/query-options.interface';
import { UID } from '@common/interfaces/uid.interface';
import {
    ICancellationFlow,
    ICancellationFlowPatchRequest,
    ICancellationFlowPostRequest,
    ICancellationPageLink,
    itemApiRequest,
    TItemV1CancellationFlowIdPatchError,
    TItemV1CancellationFlowPostError,
    TItemV1CbCancellationPageIdGetError,
} from '@src/api/item-generated-api';
import { useMutation, UseMutationResult, useQuery, UseQueryResult } from 'react-query';

const NAME = 'cancellation-flow';

const useStartCancellation = (): UseMutationResult<
    void | ICancellationFlow, // Modify the return type to include void
    IBEError<TItemV1CancellationFlowPostError>,
    ICancellationFlowPostRequest
> => {
    return useMutation(
        (props) => {
            return itemApiRequest.itemV1CancellationFlowPost(props, {}).then((res) => res.data);
        },
        {
            mutationKey: `${NAME}-cancellation-flow`,
        },
    );
};

const useCancellationFlowUpdate = (): UseMutationResult<
    void | ICancellationFlow,
    IBEError<TItemV1CancellationFlowIdPatchError>,
    { cancellation_flow_id: string; body: ICancellationFlowPatchRequest; callback?: () => void }
> => {
    return useMutation(
        (props) => {
            return itemApiRequest
                .itemV1CancellationFlowIdPatch(props.cancellation_flow_id, props.body, {})
                .then((res) => res.data);
        },
        {
            mutationKey: `${NAME}-update`,
            onSuccess: async (_, props) => {
                props.callback && props.callback();
            },
        },
    );
};

const useGetCancellationUrl = (
    id: UID,
    queryOptions?: UseQueryOptions,
): UseQueryResult<ICancellationPageLink, IBEError<TItemV1CbCancellationPageIdGetError>> => {
    return useQuery<ICancellationPageLink, IBEError<TItemV1CbCancellationPageIdGetError>>(
        `${NAME}-get-cancellation-url`,
        () => {
            return itemApiRequest.itemV1CbCancellationPageIdGet(id, {}).then((res) => res.data);
        },
        queryOptions,
    );
};

export const cancellation = {
    useStartCancellation,
    useCancellationFlowUpdate,
    useGetCancellationUrl,
};
